import { render } from "./SeedJung_Consulting.vue?vue&type=template&id=77cd1856&scoped=true"
import script from "./SeedJung_Consulting.vue?vue&type=script&lang=js"
export * from "./SeedJung_Consulting.vue?vue&type=script&lang=js"

import "./SeedJung_Consulting.vue?vue&type=style&index=0&id=77cd1856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cd1856"]])

export default __exports__